(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counter-rolls"] && !Shopify.designMode) return;
  try {
    
  class CounterRollOrder extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-design-search]');
      this.results = this.querySelector('[data-design-results]');
      this.status = this.querySelector('[data-search-status]');
      this.selected = this.querySelector('[data-selected-design]');
      this.selectedImage = this.querySelector('[data-selected-image]');
      this.selectedTitle = this.querySelector('[data-selected-title]');
      this.form = this.querySelector('form');
      this.designTitle = this.querySelector('[data-design-title]');
      this.designNumber = this.querySelector('[data-design-number]');
      this.designHandle = this.querySelector('[data-design-handle]');
      this.designUrl = this.querySelector('[data-design-url]');
      this.printLineDetail = this.querySelector('[data-print-line-detail]');
      this.printLineMedia = this.querySelector('[data-print-line-media]');
      this.printLineStatus = this.querySelector('[data-print-line-status]');
      this.sampleConfirmation = this.querySelector('[data-sample-confirmation]');
      this.submitButton = this.querySelector('[data-submit-button]');
      this.error = this.querySelector('[data-form-error]');
      this.controller = null;
      this.designNumberController = null;
      this.timer = null;

      this.searchInput?.addEventListener('input', () => this.queueSearch());
      this.results?.addEventListener('click', (event) => this.selectDesign(event));
      this.querySelector('[data-clear-design]')?.addEventListener('click', () => this.clearDesign());
      this.sampleConfirmation?.addEventListener('change', () => {
        this.error?.setAttribute('hidden', '');
        this.updateSubmitState();
      });
      this.form?.addEventListener('submit', (event) => this.validateForm(event));
      this.updateSubmitState();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.designNumberController?.abort();
      window.clearTimeout(this.timer);
    }

    queueSearch() {
      window.clearTimeout(this.timer);
      const query = this.searchInput.value.trim();

      if (this.designTitle?.value && query !== this.designTitle.value) {
        this.clearDesign(false);
      }

      if (query.length < 2) {
        this.results.innerHTML = '';
        this.status.textContent = '';
        this.searchInput.setAttribute('aria-expanded', 'false');
        return;
      }

      this.timer = window.setTimeout(() => this.search(query), 250);
    }

    async search(query) {
      this.controller?.abort();
      this.controller = new AbortController();
      this.status.textContent = this.dataset.searchingText;

      const url = new URL(this.dataset.searchUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('section_id', 'counter-roll-design-results');

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const markup = await response.text();
        this.results.innerHTML = markup;

        const counterProductHandle = this.dataset.counterProductHandle;
        if (counterProductHandle) {
          this.results.querySelector(`[data-design-handle="${CSS.escape(counterProductHandle)}"]`)?.remove();
        }

        const count = this.results.querySelectorAll('[data-design-option]').length;
        this.status.textContent = count ? '' : this.dataset.noResultsText;
        this.searchInput.setAttribute('aria-expanded', count ? 'true' : 'false');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.results.innerHTML = '';
        this.status.textContent = this.dataset.searchErrorText;
        this.searchInput.setAttribute('aria-expanded', 'false');
      }
    }

    selectDesign(event) {
      const option = event.target.closest('[data-design-option]');
      if (!option) return;
      this.resetPrintLine();
      if (this.sampleConfirmation) this.sampleConfirmation.checked = false;

      const title = option.dataset.designTitle || '';
      const designNumber = option.dataset.designNumber || '';
      const handle = option.dataset.designHandle || '';
      const url = option.dataset.designUrl || '';
      const image = option.dataset.designImage || '';

      if (this.designTitle) this.designTitle.value = title;
      if (this.designNumber) this.designNumber.value = designNumber;
      if (this.designHandle) this.designHandle.value = handle;
      if (this.designUrl) this.designUrl.value = url;
      this.searchInput.value = title;
      this.selectedTitle.textContent = title;
      this.selectedImage.src = image;
      this.selectedImage.alt = title;
      this.selected.hidden = false;
      this.results.innerHTML = '';
      this.status.textContent = '';
      this.error?.setAttribute('hidden', '');
      this.searchInput.setAttribute('aria-expanded', 'false');
      this.updateSubmitState();

      this.loadDesignMetadata(url, handle);
    }

    resetPrintLine() {
      if (this.printLineDetail) this.printLineDetail.hidden = true;
      this.printLineMedia?.replaceChildren();
      if (this.printLineStatus) {
        this.printLineStatus.hidden = true;
        this.printLineStatus.textContent = '';
      }
    }

    async loadDesignMetadata(productUrl, expectedHandle) {
      this.designNumberController?.abort();
      const controller = new AbortController();
      this.designNumberController = controller;
      const isCurrent = () =>
        !controller.signal.aborted &&
        this.designNumberController === controller &&
        this.designHandle?.value === expectedHandle;
      const showMissingImage = () => {
        if (!isCurrent()) return;
        this.resetPrintLine();
        if (this.printLineStatus) {
          this.printLineStatus.textContent = this.dataset.printLineMissingText;
          this.printLineStatus.hidden = false;
        }
      };
      if (!/^\d{6}$/.test(this.designNumber?.value || '')) {
        this.status.textContent = this.dataset.designNumberLoadingText;
      }
      if (this.printLineStatus) {
        this.printLineStatus.textContent = this.dataset.printLineLoadingText;
        this.printLineStatus.hidden = false;
      }

      try {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('section_id', 'counter-roll-design-metadata');
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));

        const markup = await response.text();
        if (!isCurrent()) return;
        const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        const designNumber = documentFragment.querySelector('[data-design-metadata]')?.dataset.designNumber || '';
        if (!/^\d{6}$/.test(designNumber)) throw new Error('Invalid design number');

        this.designNumber.value = designNumber;
        this.status.textContent = '';
        this.error?.setAttribute('hidden', '');
        const image = documentFragment.querySelector('[data-print-line-image]')?.content.querySelector('img');
        if (image && this.printLineMedia) {
          const printLineImage = image.cloneNode(true);
          printLineImage.addEventListener('error', showMissingImage, { once: true });
          this.printLineMedia.replaceChildren(printLineImage);
          this.printLineDetail.hidden = false;
          this.printLineStatus.hidden = true;
        } else {
          showMissingImage();
        }
        this.updateSubmitState();
      } catch (error) {
        if (!isCurrent()) return;
        this.status.textContent = '';
        showMissingImage();
        if (!/^\d{6}$/.test(this.designNumber?.value || '')) {
          this.error.textContent = this.dataset.designNumberErrorText;
          this.error.hidden = false;
        }
        this.updateSubmitState();
      }
    }

    clearDesign(focus = true) {
      this.designNumberController?.abort();
      this.designNumberController = null;
      this.resetPrintLine();
      if (this.sampleConfirmation) this.sampleConfirmation.checked = false;
      if (this.designTitle) this.designTitle.value = '';
      if (this.designNumber) this.designNumber.value = '';
      if (this.designHandle) this.designHandle.value = '';
      if (this.designUrl) this.designUrl.value = '';
      this.selected.hidden = true;
      this.selectedImage.removeAttribute('src');
      this.selectedTitle.textContent = '';
      this.searchInput.value = '';
      this.results.innerHTML = '';
      this.status.textContent = '';
      this.updateSubmitState();
      if (focus) this.searchInput.focus();
    }

    updateSubmitState() {
      if (!this.submitButton) return;
      const productAvailable = this.submitButton.dataset.productAvailable === 'true';
      const hasDesign = Boolean(this.designTitle?.value);
      const hasDesignNumber = /^\d{6}$/.test(this.designNumber?.value || '');
      const hasSampleApproval = Boolean(this.sampleConfirmation?.checked);
      this.submitButton.disabled = !(productAvailable && hasDesign && hasDesignNumber && hasSampleApproval);
    }

    validateForm(event) {
      const hasDesign = Boolean(this.designTitle?.value);
      const hasDesignNumber = /^\d{6}$/.test(this.designNumber?.value || '');
      const hasSampleApproval = Boolean(this.sampleConfirmation?.checked);
      if (hasDesign && hasDesignNumber && hasSampleApproval) return;

      event.preventDefault();
      if (!hasDesign) {
        this.error.textContent = this.dataset.designRequiredText;
      } else if (!hasDesignNumber) {
        this.error.textContent = this.dataset.designNumberErrorText;
      } else {
        this.error.textContent = this.dataset.sampleRequiredText;
      }
      this.error.hidden = false;
      if (!hasDesign || !hasDesignNumber) {
        this.searchInput.focus();
      } else {
        this.sampleConfirmation.focus();
      }
    }
  }

  if (!customElements.get('counter-roll-order')) {
    customElements.define('counter-roll-order', CounterRollOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
